// DS6.17 - Button or link semantics
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import commonStyles from '../../common.scss';
/**
 * A button or link in the shape of a lozenge.
 *
 * This component has no theme, so be careful where you use it. Be sure to check contrast values
 * for accessibility compliance.
 */ const LozengeButtonOrLink = (_param)=>{
    var { className } = _param, rest = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: c(commonStyles['root'], className)
    }, rest));
};
LozengeButtonOrLink.displayName = 'LozengeButtonOrLink';
export default LozengeButtonOrLink;
